/**
 * Pagination constants for the admin UI
 */
export const PAGINATION = {
  DEFAULT_SIZE: 20,
  MAX_SIZE: 500,
} as const;
